import {html} from 'lit';
import {selectSpcIsSatisfied} from '../selectors';

export const lineColumnBollard = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [],
		widgets: [
			html`
				<model-select></model-select>`
		]
	},
	{
		id: 'lightdistribution',
		label: {
			de: 'Beleuchtungsart',
			en: 'Illumination Style',
			fr: 'Style d\'Éclairage',
		},
		visual: 'lightdistribution',
		features: [
			'root::HS_Construction',
		]
	},
	{
		id: 'lightengine',
		label: {
			de: 'Optik',
			en: 'Optics',
			fr: 'Optique',
		},
		visual: 'optics',
		features: [
			'root::HS_LightEmission',
			'root::HS_LightEmissionCAFilter',
			'root::HS_LightEmissionCA',
			'root::HS_UpLight',
			'root::HS_ModuleCutoutSize_1',
			'root::LE_ColourTemperature_1',
			'root::LE_DimmingLevel_1',
			'root::LE_LightEngineShape_1',
			'root::LE_LightDistribution_1',
			'root::LE_LuminousFlux_1',
			'root::LE_LightEngineModuleSize_1',
			'root::LE_OpticalVersion_1',
			'root::LE_ReflectorColour_1',

			'root::HS_ModuleCutoutSize_2',
			'root::LE_ColourTemperature_2',
			'root::LE_DimmingLevel_2',
			'root::LE_LightEngineShape_2',
			'root::LE_LightDistribution_2',
			'root::LE_LuminousFlux_2',
			'root::LE_LightEngineModuleSize_2',
			'root::LE_OpticalVersion_2',
			'root::LE_ReflectorColour_2',

			'root::LE_UpLight_1',
			'root::LE_LightEmissionCA_1',
			'root::LE_UpLight_2',
			'root::LE_LightEmissionCA_2',
		],
		widgetsEnd_Debug: [
			html`<vertical-slider
				.title=${{de: 'Dimmstufe', en: 'Dimm Level', fr: 'Niveau de gradation'}}
				.isSatisfied= ${selectSpcIsSatisfied}
				action='decisions/setDimmLevel'
			></vertical-slider>`,
		]
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		features: [
			'root::HS_Base',
			'root::HS_HousingCoating',
			'root::HS_HousingColour',
			'root::HS_HousingShape',
			'root::HS_HousingHeight',
			'root::HS_NumberPoleDoors',
			'root::HS_HousingMountingLocationEBlock_1',
			'root::HS_HousingMountingLocationEBlock_2'
		]
	},
	{
		id: 'electricblock',
		label: {
			de: 'Steuerung',
			en: 'Control',
			fr: 'Contrôle',
		},
		visual: 'housing',
		features: [
			'root::EB_Control_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::EB_Zhaga_1',
			'root::EB_ConstantLumenTechnology_1'
		]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineColumnIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			//'root::CX_Region',
			'root::HS_Construction',
			'root::HS_LightEmission',
			'root::HS_LightEmissionCAFilter',
			'root::HS_LightEmissionCA',
			'root::HS_UpLight',
		],
		widgets: [
			html`
				<model-select></model-select>`
		]
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		features: [
			'root::HS_Base',
			'root::HS_HousingCoating',
			'root::HS_HousingColour',
			'root::HS_HousingShape',
			'root::HS_HousingHeight',
			'root::HS_NumberPoleDoors',
			'root::HS_ModuleCutoutSize_1',
			'root::HS_ModuleCutoutSize_2',
			'root::HS_HousingPowerConnection',
			'root::HS_HousingPowerConnectionPosition',
			'root::HS_HousingMountingLocationEBlock_1',
			'root::HS_HousingMountingLocationEBlock_2',
		]
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		features: [
			'root::LE_ColourTemperature_1',
			'root::LE_DimmingLevel_1',
			'root::LE_LightEngineShape_1',
			'root::LE_LightDistribution_1',
			'root::LE_LuminousFlux_1',
			'root::LE_LightEngineModuleSize_1',
			'root::LE_OpticalVersion_1',
			'root::LE_ReflectorColour_1',
			'root::LE_UpLight_1',
			'root::LE_LightEmissionCA_1',
		]
	},
	{
		id: 'lightengineB',
		label: {
			de: 'Optik B',
			en: 'Optics B',
			fr: 'Optique B',
		},
		visual: 'housing',
		features: [
			'root::LE_ColourTemperature_2',
			'root::LE_DimmingLevel_2',
			'root::LE_LightEngineShape_2',
			'root::LE_LightDistribution_2',
			'root::LE_LuminousFlux_2',
			'root::LE_LightEngineModuleSize_2',
			'root::LE_OpticalVersion_2',
			'root::LE_ReflectorColour_2',
			'root::LE_UpLight_2',
			'root::LE_LightEmissionCA_2',
		]
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		features: [
			'root::EB_ConstantLumenTechnology_1',
			'root::EB_Control_1',
			'root::EB_EBlockModuleSize_1',
			'root::EB_EBlockMountingType_1',
			'root::EB_EBlockShape_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::EB_Wattage_1',
			'root::EB_Zhaga_1'
		]
	},
	{
		id: 'electricB',
		label: {
			de: 'EBlock B',
			en: 'EBlock B',
			fr: 'EBlock B',
		},
		visual: 'housing',
		features: [
			'root::EB_ConstantLumenTechnology_2',
			'root::EB_Control_2',
			'root::EB_EBlockModuleSize_2',
			'root::EB_EBlockMountingType_2',
			'root::EB_EBlockShape_2',
			'root::EB_ElectricalProtectionClass_2',
			'root::EB_Wattage_2',
			'root::EB_Zhaga_2'
		], // null
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineBollardIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			//'root::CX_Region',
			'root::HS_Construction',
			'root::HS_LightEmission',
			'root::HS_LightEmissionCAFilter',
			'root::HS_LightEmissionCA',
			'root::HS_UpLight',
		],
		widgets: [
			html`
				<model-select></model-select>`
		]
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		features: [
			'root::HS_Base',
			'root::HS_HousingCoating',
			'root::HS_HousingColour',
			'root::HS_HousingShape',
			'root::HS_HousingHeight',
			'root::HS_NumberPoleDoors',
			'root::HS_ModuleCutoutSize_1',
			'root::HS_ModuleCutoutSize_2',
			'root::HS_HousingPowerConnection',
			'root::HS_HousingPowerConnectionPosition',
			'root::HS_HousingMountingLocationEBlock_1',
			'root::HS_HousingMountingLocationEBlock_2',
		]
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		features: [
			'root::LE_ColourTemperature_1',
			'root::LE_DimmingLevel_1',
			'root::LE_LightEngineShape_1',
			'root::LE_LightDistribution_1',
			'root::LE_LuminousFlux_1',
			'root::LE_LightEngineModuleSize_1',
			'root::LE_OpticalVersion_1',
			'root::LE_ReflectorColour_1',
			'root::LE_UpLight_1',
			'root::LE_LightEmissionCA_1',
		]
	},
	{
		id: 'lightengineB',
		label: {
			de: 'Optik B',
			en: 'Optics B',
			fr: 'Optique B',
		},
		visual: 'housing',
		features: [
			'root::LE_ColourTemperature_2',
			'root::LE_DimmingLevel_2',
			'root::LE_LightEngineShape_2',
			'root::LE_LightDistribution_2',
			'root::LE_LuminousFlux_2',
			'root::LE_LightEngineModuleSize_2',
			'root::LE_OpticalVersion_2',
			'root::LE_ReflectorColour_2',
			'root::LE_UpLight_2',
			'root::LE_LightEmissionCA_2',
		]
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		features: [
			'root::EB_ConstantLumenTechnology_1',
			'root::EB_Control_1',
			'root::EB_EBlockModuleSize_1',
			'root::EB_EBlockMountingType_1',
			'root::EB_EBlockShape_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::EB_Wattage_1',
			'root::EB_Zhaga_1'
		]
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

export const lineSingular = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		widgets: [
			html`
				<model-select></model-select>`
		]
	},
	{
		id: 'lightengine',
		label: {
			de: 'Optik',
			en: 'Optics',
			fr: 'Optique',
		},
		visual: 'optics',
		features: [
			'root::HS_LightEmission',
			'root::HS_LightEmissionCAFilter',
			'root::HS_LightEmissionCA',
			'root::HS_UpLight',

			'root::HS_ModuleCutoutSize_1',
			'root::HS_ModuleCutoutSize_2',
			'root::LE_ColourTemperature_1',
			'root::LE_DimmingLevel_1',
			'root::LE_LightDistribution_1',
			'root::LE_LuminousFlux_1',
			'root::LE_LightEngineModuleSize_1',
			'root::LE_OpticalVersion_1',
			'root::LE_ReflectorColour_1',
			'root::LE_ColourTemperature_2',
			'root::LE_DimmingLevel_2',
			'root::LE_LightEngineShape_2',
			'root::LE_LightDistribution_2',
			'root::LE_LuminousFlux_2',
			'root::LE_LightEngineModuleSize_2',
			'root::LE_OpticalVersion_2',
			'root::LE_ReflectorColour_2',

			'root::LE_UpLight_1',
			'root::LE_LightEmissionCA_1',
			'root::LE_UpLight_2',
			'root::LE_LightEmissionCA_2',
		],
		widgets: []
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'housing',
		features: [
			'root::HS_Base',
			'root::HS_HousingCoating',
			'root::HS_HousingColour',
			'root::HS_HousingShape',
			'root::HS_HousingHeight',
			'root::HS_NumberPoleDoors',
			'root::HS_HousingMountingLocationEBlock_1',
			'root::HS_HousingMountingLocationEBlock_2'
		],
		widgets: []
	},
	{
		id: 'electricblock',
		label: {
			de: 'Steuerung',
			en: 'Control',
			fr: 'Contrôle',
		},
		visual: 'optics',
		features: [
			'root::EB_Control_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::EB_Zhaga_1',
			'root::EB_ConstantLumenTechnology_1'
		],
		widgets: []
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];
export const lineSingularIntern = [
	{
		id: 'variant',
		label: {
			de: 'Modell',
			en: 'Model',
			fr: 'Modèle',
		},
		visual: 'model',
		features: [
			// 'root::CX_Region',
			'root::HS_LightEmission',
			'root::HS_LightEmissionCAFilter',
			'root::HS_LightEmissionCA',
			'root::HS_UpLight',
			'root::HS_Construction',
		],
		widgets: [
			html`
				<model-select></model-select>`
		]
	},
	{
		id: 'design',
		label: {
			de: 'Design',
			en: 'Design',
			fr: 'Design',
		},
		visual: 'model',
		features: [
			// 'root::CX_Region',
			'root::HS_Base',
			'root::HS_HousingCoating',
			'root::HS_HousingColour',
			'root::HS_HousingShape',
			'root::HS_HousingHeight',
			'root::HS_NumberPoleDoors',
			'root::HS_ModuleCutoutSize_1',
			'root::HS_ModuleCutoutSize_2',
			'root::HS_HousingPowerConnection',
			'root::HS_HousingPowerConnectionPosition',
			'root::HS_HousingMountingLocationEBlock_1',
			'root::HS_HousingMountingLocationEBlock_2',		],
		widgets: []
	},
	{
		id: 'lightengineA',
		label: {
			de: 'Optik A',
			en: 'Optics A',
			fr: 'Optique A',
		},
		visual: 'housing',
		features: [
			'root::LE_ColourTemperature_1',
			'root::LE_DimmingLevel_1',
			'root::LE_LightEngineShape_1',
			'root::LE_LightDistribution_1',
			'root::LE_LuminousFlux_1',
			'root::LE_LightEngineModuleSize_1',
			'root::LE_OpticalVersion_1',
			'root::LE_ReflectorColour_1',
			'root::LE_UpLight_1',
			'root::LE_LightEmissionCA_1',
		],
		widgets: []
	},
	{
		id: 'electricA',
		label: {
			de: 'EBlock A',
			en: 'EBlock A',
			fr: 'EBlock A',
		},
		visual: 'housing',
		features: [
			'root::EB_ConstantLumenTechnology_1',
			'root::EB_Control_1',
			'root::EB_EBlockModuleSize_1',
			'root::EB_EBlockMountingType_1',
			'root::EB_EBlockShape_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::EB_Wattage_1',
			'root::EB_Zhaga_1'
		],
		widgets: []
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

